import { render, staticRenderFns } from "./rebate.vue?vue&type=template&id=2bbf0254&scoped=true&"
import script from "./rebate.vue?vue&type=script&lang=js&"
export * from "./rebate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bbf0254",
  null
  
)

export default component.exports